import React from "react";
import styles from "./BuildingLoadingSchoolsView.module.styl";
import { Heading } from "uikit/components";
import { arrayOf, number, shape, string } from "prop-types";
import BuildingLoadingSchoolRow from "../BuildingLoadingSchoolRow/BuildingLoadingSchoolRow";

export default function BuildingLoadingSchoolsView({ schoolsData, schoolsCount }) {
    return (
        <>
            <Heading size={"h2"} className={styles.heading} name="building-loading-schools-header">
                Организации, использующие объект
            </Heading>
            <div className={styles.counter}>Количество организаций: {schoolsCount} </div>
            <div className={styles.container} data-test-name="organization_using_object">
                {schoolsData?.map((item) => (
                    <BuildingLoadingSchoolRow key={item.id} schoolData={item} />
                )) ?? []}
            </div>
        </>
    );
}

BuildingLoadingSchoolsView.propTypes = {
    schoolsData: arrayOf(
        shape({
            id: number.isRequired,
            name: string.isRequired,
        }),
    ),
    schoolsCount: number.isRequired,
};
